import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { storageKeys } from '../../../../../../stores/DebuggerStore';
import { BLACK, YELLOW } from '../../Styles';
import { StyledButton } from '../Styles';

export const LogToDevWindowButton = observer(() => {
  const {
    DebuggerStore: { setDebugItem },
  } = useStores();

  return (
    <StyledButton
      bgColor={YELLOW}
      color={BLACK}
      onClick={() => {
        setDebugItem(storageKeys.readLogWhenConnected, true);
        setDebugItem(storageKeys.writeToLogWhenConnected, false);
        setDebugItem(storageKeys.writeLogToDevWindow, true);
        setDebugItem(storageKeys.writeLogToConsole, false);

        setDebugItem(storageKeys.skipPingPongWhenConnected, true);
        setDebugItem(storageKeys.maxLogStorageSizeInKb, 4000);
        setDebugItem(storageKeys.maxMessageLength, 150);
        setDebugItem(storageKeys.engineLogLevel, 'off');
        setDebugItem(storageKeys.uiLogLevel, 'verbose');

        //pong emit seems to keep the settings from refreshing and we need a double click to see changes
        setDebugItem(storageKeys.readLogWhenConnected, true);
        setDebugItem(storageKeys.writeToLogWhenConnected, false);
        setDebugItem(storageKeys.writeLogToDevWindow, true);
        setDebugItem(storageKeys.writeLogToConsole, false);

        setDebugItem(storageKeys.skipPingPongWhenConnected, true);
        setDebugItem(storageKeys.maxLogStorageSizeInKb, 4000);
        setDebugItem(storageKeys.maxMessageLength, 150);
        setDebugItem(storageKeys.engineLogLevel, 'off');
        setDebugItem(storageKeys.uiLogLevel, 'verbose');
      }}
      style={{ cursor: 'pointer' }}
    >
      UI Logging
    </StyledButton>
  );
});

export default LogToDevWindowButton;
